import React, {Component} from 'react';
import '../../Style.css';
import { BrowserRouter, Link } from 'react-router-dom';


class about extends Component{

    render () {
  
    return (
      <BrowserRouter>
      
    <div className = "AboutText">
       <div className="AboutParagraph">
     <p className="About">20+ years as a Visual Artist. My technical knowledge as a Programmer has improved my ability in terms of Automation and 3D Space within a Digital Landscape, as well as better understanding how things work under the hood. My passion in life has always been art, and my technical experience as a programmer has improved my abilities to shine as a 3D artist and has improved my efficiency to do so.</p></div>
     <div className="SkillsAndSoftware">
     <h1 className="certifications">Certifications:</h1>
     <h2 className="certifications">-3D Modeling Essentials, CG Spectrum (2025)</h2>
     <h2 className="certifications">-Python for Data Science, AI & Development (2023)</h2>
     <h2 className="certifications">-Certificate of Completion in Software Engineering (2019)</h2>
     
       <h2 className= "SkillsTitle">Skills</h2>
     <p className="SkillsParagraphText">
     <h2>Advanced:</h2> Hard Surface Modeling, Soft Surface Modeling, Prop Artistry, Shape Language, Color Theory, Set Dressing, 3D Texturing, UV Unwrapping, Low/High Poly Baking, Modular Kits, Lightmap Baking, Trim Sheets, Texel Density, Tileable Materials, Decals, Shaders, Lumen, Rendering, Photogrammetry, Drawing, Painting, Photography, Stereo and 5.1 recording, Mixing & Editing Audio, ADR, SFX (Foley, Soft FX, Hard FX)
     <h2>Moderate:</h2>Character Modeling, Niagara Effects, Linux (Mac OS), Linux, Python, Ubuntu, AWS, Apache, Nginx, SEO, PHP, Materialize UI, Bootstrap, React, PostgreSQL, Nodejs, Express, MongoDB, Terminal Commands, Website Migrations (DNS Records, Domain Registrar), HTML, CSS, Javascript, Git commands, Algebra, Trigonometry, Calculus, Discrete Mathematics, Computer Science
    </p>
    
      <h2 className= "SoftwareTitle">Software</h2>
    <p className="SoftwareParagraphText">
    <h2>Advanced:</h2>Unreal Engine, Unity, Maya, Blender, Z-Brush, Substance Painter, Substance Designer, Marmoset Renderer, Materialize (Bounding Box), Adobe Audition, phpMyAdmin, Gutenberg, Wordpress, Mailchimp, Text Editors, Final Cut Pro, Adobe Suite: Photoshop; Premiere; Audition, ProTools, Illustrator, After Effects 
    <h2>Moderate:</h2>Docker, Eclipse (Java), In Design
    </p>  
    </div>
    </div>
   
    </BrowserRouter>
    )}
    }
export default about;